module.exports = __webpack_public_path__ + "static/img/banner2.394cb66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/banner2.jpg
// module id = gcF1
// module chunks = 0